import clsx from 'clsx';

import styles from './PopupButton.module.scss';

const PopupButton = ({className, children, onClick, guideTarget}) => (
  <div className={clsx(styles.btn, className)} onClick={onClick} data-navigation-guide={guideTarget}>
    {children}
  </div>
);

export default PopupButton;
